<template>
    <el-table
        :data="contents.results"
        ref="table"
        :stripe="stripe"
        style="width: 100%"
        class="ns-paginate-table"
        :max-height="infiniteScroll ? maxHeight : 'auto'"
        :class="{'dark-theme': dark}"
        @sort-change="emitSortChange"
    >
        <!-- TODO le formatter ici ne peut pas macher si l'on utilise un slot -->
        <el-table-column
            v-for="(item, index) in allowedListFieldToDisplay"
            :key="item.key"
            :prop="item.key"
            :label="item.verbose"
            :formatter="formatListTableCell"
            sortable="custom"
        >
            <template slot-scope="scope">
                <el-button
                    v-if="index === 0"
                    type="text"
                    @click="emitShowModalEditObject(scope.row)"
                >
                    {{ allowedListFieldToDisplay[index].valueFormatter ? allowedListFieldToDisplay[index].valueFormatter(scope.row[item.key]) : scope.row[item.key] }}
                </el-button>
                <template v-else>
                    {{ allowedListFieldToDisplay[index].valueFormatter ? allowedListFieldToDisplay[index].valueFormatter(scope.row[item.key]) : scope.row[item.key] }}
                </template>
            </template>
        </el-table-column>
        <slot name="custom-column"></slot>

        <el-table-column
            v-if="displayStatusColumn"
            :label="getVerbose('ns_paginate_table_column_status_label')"
            :prop="getVerbose('ns_paginate_table_column_status_label')"
            sortable="custom"
        >
            <template slot-scope="scope">
                <i
                    v-tooltip.top="screamCaseToSeparateWord(scope.row.status)"
                    v-if="getRelatedIconStatus(scope.row.status) !== null"
                    :class="getRelatedIconStatus(scope.row.status)
                    "
                    class="statusIcon"
                ></i>
                <template v-else>
                    {{ screamCaseToSeparateWord(scope.row.status) }}
                </template>
            </template>
        </el-table-column>

        <el-table-column
            v-if="operationsColumn.length > 0"
            :label="getVerbose('ns_paginate_table_column_operations_label')"
            :width="operationsColumn.length > 1 ? (operationsColumn.length + 1) * 60 : 150"
            sortable="custom"
            fixed="right"
            class="operations"
        >

            <template
                slot-scope="scope"
            >
                <operation-column
                    :operations-column="operationsColumn"
                    :can-edit-model="canEditModel"
                    :row-item="scope.row"
                    @emitShowModalEditObject="emitShowModalEditObject"
                ></operation-column>
<!--                 <el-button
                    v-tooltip.top="getVerbose('ns_paginate_table_column_edit_tooltip')"
                    v-if="canEditModel"
                    class="operation-button"
                    icon="ti ti-pencil"
                    type="primary"
                    @click="emitShowModalEditObject(scope.row)"
                ></el-button>
 -->            </template>
        </el-table-column>

        <infinite-loading
            v-if="infiniteScroll"
            slot="append"
            force-use-infinite-wrapper=".el-table__body-wrapper"
            noMore="No More message"
            @infinite="fetchMoreData"
        >
            <template slot="no-more">
                <div class="demo-item">
                    {{ noMoreMessage }}
                </div>
            </template>
        </infinite-loading>
    </el-table>
</template>

<script>
import OperationColumn from './operations-column.vue';
import InfiniteLoading from 'vue-infinite-loading';
import {mapGetters} from 'vuex';

export default {

    components: {
        OperationColumn,
        InfiniteLoading
    },

    props: {
        contents: {
            type: Object,
            required: true,
        },
        listFieldToDisplay: {
            type: Array,
            required: true,
        },
        customStatus: {
            type: Object,
            required: true
        },
        operationsColumn: {
            type: Array,
            required: true
        },
        canEditModel: {
            type: Boolean,
            required: true
        },
        dark: {
            type: Boolean,
            required: true
        },
        infiniteScroll: {
            type: Boolean,
            required: false,
            default: false,
        },
        maxHeight: {
            type: String,
            required: false,
            default: '500',
        },
        noMoreMessage: {
            type: String,
            required: false,
            default: 'No more data',
        },
        orderingProperty: {
            type: Object,
            required: true,
        },
        stripe: {
            type: Boolean,
            required: false,
            default: false
        },
    },

    data: function(){
        return {

        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getVerbose'
        ]),
        allowedListFieldToDisplay() {
            return this.listFieldToDisplay.filter((field) => {
                // [0] car on 'this.contents.results' et la liste des models et tous les models ont la même signature. Donc pour rechercher si une clé existe sur un model in peu prendre n'importe lequel
                if (this.contents.results.length > 0) {
                    return this.contents.results[0].hasOwnProperty(field.key) && field.key !== 'status';
                } else {
                    return field.key !== 'status';
                }
            });
        },
        displayStatusColumn (){
            return this.listFieldToDisplay.find((item) => item.key === 'status');
        },

    },
    mounted (){
        for(let col of this.$refs.table.columns){
            let fieldToDisplay = this.listFieldToDisplay.find((item) => item.orderBy === this.orderingProperty.property);
            let property = fieldToDisplay ? fieldToDisplay.key : this.orderingProperty.property;
            if(col.property === property){
                col.order = this.orderingProperty.sign === '-' ? 'descending' : 'ascending';
                break;
            }
        }
    },
    methods: {
        fetchMoreData ($state){
            this.$emit('on-fetch-more-data', $state);
        },
        formatListTableCell (row, column, cellValue, index){
            let relatedFieldToDisplay = this.allowedListFieldToDisplay.find((field) => field.key === column.property);
            if(relatedFieldToDisplay && relatedFieldToDisplay.hasOwnProperty('property')){
                return cellValue[relatedFieldToDisplay.property];
            }
            return cellValue;
        },
        screamCaseToSeparateWord (word){
            return word.replace(/\_/g, ' ');
        },
        getRelatedIconStatus (status){

            if(status === 'FAILED' || this.hasRelatedCustomStatus('failed', status)){
                return 'el-icon-error';
            }else if(status === 'TIMEOUT' || this.hasRelatedCustomStatus('timeout', status)){
                return 'ti-time';
            }else if(status === 'COMPLETED' || this.hasRelatedCustomStatus('completed', status)){
                return 'el-icon-success';
            }else if(status === 'PENDING' || this.hasRelatedCustomStatus('pending', status)){
                return 'ti-line-dotted ';
            }else if(status === 'RUNNING' || this.hasRelatedCustomStatus('running', status)){
                return 'el-icon-loading';
            }else{
                return null;
            }
        },

        hasRelatedCustomStatus (status, statusToMatch){
            if(this.customStatus.hasOwnProperty(status)){
                return this.customStatus[status].includes(statusToMatch);
            }
            return false;
        },
        emitShowModalEditObject(object) {
            this.$emit('showModalEditObject', object);
        },
        emitSortChange(sortData) {
            this.$emit('sortChange', sortData);
        }

    },
};
</script>

<style lang="scss">


</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/nsPaginate2/-new-ns-paginate-list.vue